module.exports = __webpack_public_path__ + "static/media/photo163.f6e01094.jpg";